eyebrow: "Built On"
headline: "A foundation of<br/><em>best-in-class open tools.</em>"

row1:
  - "FastAPI"
  - "React"
  - "Tesseract OCR"
  - "PyMuPDF"
  - "LangChain"
  - "FAISS"
  - "Docker"
  - "PostgreSQL"
  - "Redis"
  - "GitHub Actions"
  - "AWS S3"
  - "N8N"
  - "Composio"

row2:
  - "Ollama"
  - "ChromaDB"
  - "Mistral"
  - "Python 3.12"
  - "TypeScript"
  - "Pydantic"
  - "OpenCV"
  - "Celery"
  - "Kubernetes"
  - "AWS Textract"
  - "Vite"
  - "Supabase"
